import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Frown, Smile, TrendingDown, TrendingUp, Clock, Zap } from 'lucide-react';
export function TransformationSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-charcoal relative" data-id="element-264">
      <div className="max-w-6xl mx-auto" data-id="element-265">
        <div className="grid md:grid-cols-[1fr_auto_1fr] gap-8 items-center mb-16" data-id="element-266">
          {/* Before Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-charcoal-dark border border-white/5 p-8 sm:p-10 rounded-3xl relative overflow-hidden h-full" data-id="element-267">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-900/50 to-transparent" data-id="element-268" />
            <div className="flex items-center gap-4 mb-8" data-id="element-269">
              <div className="w-12 h-12 rounded-full bg-red-900/20 flex items-center justify-center" data-id="element-270">
                <Frown className="w-6 h-6 text-red-400/70" data-id="element-271" />
              </div>
              <h3 className="text-2xl font-serif text-cream-muted" data-id="element-272">Antes</h3>
            </div>

            <ul className="space-y-6" data-id="element-273">
              {[{
              icon: TrendingDown,
              text: 'Sin ingresos extra'
            }, {
              icon: Clock,
              text: 'Perdida y confundida'
            }, {
              icon: Zap,
              text: 'Frustración'
            }].map((item, i) => <li key={i} className="flex items-center gap-4 text-cream-muted/70 text-lg" data-id="element-274">
                  <item.icon className="w-6 h-6 flex-shrink-0 opacity-50" data-id="element-275" />
                  <span data-id="element-276">{item.text}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Arrow */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.5
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="hidden md:flex w-16 h-16 rounded-full bg-warmBrown border border-gold/20 items-center justify-center z-10 shadow-[0_0_30px_rgba(212,168,83,0.15)]" data-id="element-277">
            <ArrowRight className="w-8 h-8 text-gold" data-id="element-278" />
          </motion.div>

          {/* After Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gradient-to-b from-warmBrown to-charcoal border border-gold/30 p-8 sm:p-10 rounded-3xl relative overflow-hidden shadow-[0_0_50px_rgba(212,168,83,0.1)] h-full" data-id="element-279">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gold to-gold-dark" data-id="element-280" />
            <div className="absolute -top-24 -right-24 w-48 h-48 bg-gold/20 blur-[60px] rounded-full pointer-events-none" data-id="element-281" />

            <div className="flex items-center gap-4 mb-8 relative z-10" data-id="element-282">
              <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center border border-gold/30" data-id="element-283">
                <Smile className="w-6 h-6 text-gold" data-id="element-284" />
              </div>
              <h3 className="text-2xl font-serif text-gold" data-id="element-285">Después</h3>
            </div>

            <ul className="space-y-6 relative z-10" data-id="element-286">
              {[{
              icon: TrendingUp,
              text: 'Vendiendo focaccias y generando dinero real'
            }, {
              icon: Clock,
              text: 'Sistema simple que podés repetir'
            }, {
              icon: Zap,
              text: 'Confianza total'
            }].map((item, i) => <li key={i} className="flex items-center gap-4 text-cream text-lg" data-id="element-287">
                  <item.icon className="w-6 h-6 flex-shrink-0 text-gold" data-id="element-288" />
                  <span className="font-medium" data-id="element-289">{item.text}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-290">
          <div className="inline-block bg-gold/10 border border-gold/30 rounded-full px-8 py-4 shadow-[0_0_30px_rgba(212,168,83,0.15)]" data-id="element-291">
            <p className="text-2xl md:text-3xl font-serif font-bold text-gold" data-id="element-292">
              💰 Generando ingresos desde la primera semana
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}